import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { format } from "date-fns";
import { Dialog } from "primereact/dialog";
import { ILogin,  } from "../../../models/Login";
import { safeFormatDate } from "../../../models/DateFormatMapper";

interface ITimeSheetReport {
    type: string;
    activeCount: number;
    uploadedCount: number;
}
export interface IModel2 {
    open: boolean,
    singleData: any
}
export const ActiveTimeSheetReport = () => {
    const [tableData, setTableData] = useState<{ tableData: Array<ITimeSheetReport>, loading: boolean }>({
        tableData: [],
        loading: false
    });
    const [subTable, setSubTable] = useState({ singleData: {}, open: false } as IModel2);
    const [tableData1, setTableData1] = useState<{ tableData1: Array<ITimeSheetReport>, loading: boolean }>({
        tableData1: [],
        loading: false
    });
    const dt = useRef<any>(null);
    const toast = useRef<any>(null);

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Add TimeSheet Report</h5>
        </div>
    );

    const loadTableData = async () => {

        setTableData(prev => ({ ...prev, loading: true }));
        try {
            const subResponse = await Fetch("Timesheet/getActiveConsSubCount", "GET", null, `userType=Sub`, null);
            const subData: number = subResponse ? await subResponse.json() : [];

            const conResponse = await Fetch("Timesheet/getActiveConsSubCount", "GET", null, `userType=Con`, null);
            const conData: number = conResponse ? await conResponse.json() : [];

            const SubuploadedResponse = await Fetch("Timesheet/getPervWeekTSCount", "GET", null, `userType=Sub`, null);
            const SubuploadedData: any = SubuploadedResponse ? await SubuploadedResponse.json() : {};

            const ConuploadedResponse = await Fetch("Timesheet/getPervWeekTSCount", "GET", null, `userType=Con`, null);
            const ConuploadedData: any = ConuploadedResponse ? await ConuploadedResponse.json() : {};

            const InHouseuploadedResponse = await Fetch("Timesheet/getPervWeekTSCount", "GET", null, `userType=InHouse`, null);
            const uploadedData: any = InHouseuploadedResponse ? await InHouseuploadedResponse.json() : {};

            const combinedData: ITimeSheetReport[] = [
                { type: "SubVendor", activeCount: subData, uploadedCount: SubuploadedData?.count ?? 0 },
                { type: "Consultant", activeCount: conData, uploadedCount: ConuploadedData?.count ?? 0 },
                { type: "InHouse", activeCount: 0, uploadedCount: uploadedData?.count ?? 0 }
            ];

            setTableData({ tableData: combinedData, loading: false });
        } catch (error) {
            setTableData(prev => ({ ...prev, loading: false }));
        }
    };


    const loadTableData1 = async (userType: string) => {
        setTableData1(prev => ({ ...prev, loading: true }));
        if (userType == "SubVendor") {
            userType = "Sub"
        } else if (userType == "Consultant") {
            userType = "Con"

        }
        try {
            const response = await Fetch(
                "Timesheet/getPervWeekTSCount",
                "GET",
                null,
                `userType=${userType}`,
                null
            );

            if (response) {
                const result = await response.json();
                const data: Array<any> = result.data ?? []; // ✅ pick data array
                setTableData1({ tableData1: data, loading: false });
            }
        } catch (error) {
            setTableData1(prev => ({ ...prev, loading: false }));
        }
    };



    const onHide = () => {
        setSubTable({ open: false, singleData: {}, })
    }

    useEffect(() => {
        loadTableData(); // only load the main table once on component mount
    }, []);


    const noOfUploded = (rowData: any) => (

        <span onClick={() => { console.log(rowData); setSubTable({ open: true, singleData: rowData }); loadTableData1(rowData.type); }} className="cursor-pointer text-cyan-700 underline" >  {rowData.uploadedCount} </span>
    );

    const fromDate = (rowData: any) => {
        let date;
        if (rowData.fromDate) date = format(new Date(rowData.fromDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const toDate = (rowData: any) => {
        let date;
        if (rowData.toDate) date = format(new Date(rowData.toDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };


    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj?.date_Format;
    return (
        <>
            <Toolbar className="mb-1 py-0" />
            <DataTable
                style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                resizableColumns showGridlines columnResizeMode="expand"
                exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                ref={dt} size="small" stripedRows scrollable scrollHeight="70vh"
                value={tableData.tableData}
                header={header}
                loading={tableData.loading}
            >
                <Column field="type" header="Type" />
                <Column field="activeCount" header="No. of Active" />
                <Column field="uploadedCount" header="last Week Uploaded Timesheets" body={noOfUploded} />
            </DataTable>
            <Toast ref={toast} />
            <Dialog visible={subTable.open} style={{ width: '80vw' }} header="" modal className="p-fluid" onHide={onHide}>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                    ref={dt} size="small" stripedRows showGridlines scrollable scrollHeight="70vh" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                    value={tableData1.tableData1} loading={tableData1.loading}
                >
                    <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="consultant_Name" header="Consultant" sortable />
                    {/* <Column field="fromDate" header="From Date" sortable body={fromDate} /> */}
                     <Column field="fromDate" header="From Date" sortable body={(rowData: any) =>safeFormatDate(rowData.fromDate, 'dd/MM/yyyy', DateFormat)} />
                    {/* <Column field="toDate" header="To Date" sortable body={toDate} /> */}
                    <Column field="toDate" header="To Date" sortable body={(rowData: any) => safeFormatDate(rowData.toDate, 'dd/MM/yyyy', DateFormat)} />
                    <Column field="timeSheet_Status" header="Status" sortable />

                </DataTable>

            </Dialog>
        </>
    );
};
